import type { CSSProperties } from 'react';
import type { GraphNode } from '../../api/knowledge';
import './NodeTooltip.css';

interface Props {
  node: GraphNode;
  color: string;
  style?: CSSProperties;
}

export function NodeTooltip({ node, color, style }: Props) {
  const subtitle = node.subdomain
    ? `${node.domain} / ${node.subdomain}`
    : node.cluster
      ? `${node.domain} / ${node.cluster}`
      : node.domain;

  return (
    <div
      className="node-tooltip"
      style={{ ...style, borderColor: withAlpha(color, 0.35) }}
    >
      <div className="node-tooltip__title">{node.title}</div>
      <div className="node-tooltip__subtitle" style={{ color: withAlpha(color, 0.85) }}>
        {subtitle}
      </div>
      <div className="node-tooltip__stats">
        <div>
          <div className="label">Quality</div>
          <div className="node-tooltip__value" style={{ color }}>
            {node.quality.toFixed(2)}
          </div>
        </div>
        <div>
          <div className="label">Type</div>
          <div className="node-tooltip__value">{node.type}</div>
        </div>
        {node.topics.length > 0 && (
          <div>
            <div className="label">Topics</div>
            <div className="node-tooltip__value node-tooltip__topics">
              {node.topics.slice(0, 2).join(', ')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function withAlpha(color: string, alpha: number): string {
  if (color.startsWith('rgba')) {
    return color.replace(/rgba?\(([^,]+),([^,]+),([^,]+),([^)]+)\)/, `rgba($1,$2,$3,${alpha})`);
  }
  if (color.startsWith('rgb(')) {
    return color.replace('rgb(', 'rgba(').replace(')', `,${alpha})`);
  }
  if (color.startsWith('#')) {
    const hex = color.replace('#', '');
    const bigint = parseInt(
      hex.length === 3
        ? hex.split('').map((c) => c + c).join('')
        : hex,
      16,
    );
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r},${g},${b},${alpha})`;
  }
  return color;
}
